module.exports = __webpack_public_path__ + "img/fr.81465a1d.svg";